import { SxProps } from "@mui/material";

export const sxFilterSelect: SxProps = {
    fontFamily: 'Unimed-Sans', 
    color: '#383838', 
    fontSize: '14px', 
    svg: {color: '#383838'},
}

export const sxMenuItem: SxProps = {
    fontFamily: 'Unimed-Sans', 
    fontSize: '14px', 
    paddingTop: '12px', 
    margin: '0px', 
    paddingLeft: '24px', 
    paddingBottom: '12px'
}